module.exports = __webpack_public_path__ + "img/EtiquetaFase2.55f091dd.png";